import plant1 from "./plant-photos/plants/half-moon.jpeg";
import plant2 from "./plant-photos/plants/alocasia-frydek.jpeg";
import plant3 from "./plant-photos/plants/alocasia-portodora.jpeg";
import plant4 from "./plant-photos/plants/alocasia-zebrina.jpeg";
import plant5 from "./plant-photos/plants/calathea.jpeg";
import plant6 from "./plant-photos/plants/ficus.jpeg";
import plant7 from "./plant-photos/plants/monstera.jpg";
import plant8 from "./plant-photos/plants/philodendron-gloriosum.jpeg";
import plant9 from "./plant-photos/plants/philodendron-verrucosum.jpeg";
import plant10 from "./plant-photos/plants/pilea.jpeg";
import plant11 from "./plant-photos/plants/pothos.jpeg";
import plant12 from "./plant-photos/plants/satin-pothos.jpeg";
import plant13 from "./plant-photos/plants/stephania-erecta.jpeg";
import plant14 from "./plant-photos/plants/anthurium-clarinervium.jpeg";
import plant15 from "./plant-photos/plants/jewel-orchid.jpeg";
import plant16 from "./plant-photos/plants/philodendron-micans.jpeg";
import plant17 from "./plant-photos/plants/pink-princess.jpeg";
import plant18 from "./plant-photos/plants/string-of-turtles.jpeg";
import plant19 from "./plant-photos/plants/white-princess.jpeg";
import plant20 from "./plant-photos/plants/fern-asparagus.jpeg";
import plant21 from "./plant-photos/plants/hoya-linearis.jpeg";

const plants = [
  {
    id: 1,
    name: "Monstera deliciosa variegata Halfmoon",
    image: plant1,
    size: "medium",
    price: 300,
    description:
      "Variegated Monstera Deliciosa var. Borsigiana, a.k.a Monstera albo, with white variegated leaves is probably one of the most sought after plants these days. We have only got a handful of them as they are very hard to get.",
    quantity: 1,
  },

  {
    id: 2,
    name: ` Alocasia Micholitziana Frydek`,
    image: plant2,
    size: "small",
    price: 25,
    description:
      "Alocasia Micholitziana ‘Frydek’ is a rare, glamorous specimen with an elegant touch. The soft velvet leaf texture is complimented by the iconic arrowhead shape. What makes this alocasia unique are the sharp, white veins that dissect the deep green leaves. This is a must have for all true plant lovers.",
    quantity: 1,
  },

  {
    id: 13,
    name: "Stephania Erecta",
    image: plant13,
    size: "medium",
    price: 46,
    description:
      "Stephania Erecta is one of the highest trending house plants of the last years. Its potato like tuber lays dormant throughout winter but explodes with growth in spring sending out climbing vines which vigorously fill a space. Its matt green circular leaves are dissected with light green veins in a spoked pattern.",
    quantity: 1,
  },

  {
    id: 14,
    name: "Anthurium Clarinervium",
    image: plant14,
    size: "medium",
    price: 55,
    description: "Anthurium Clarinervium is a very interesting plant which unlike other Anthuriums is grown for its thick, green, heart-shaped & leather-like leaves with bright coloured veins. It’s a spectacular plant from Araceae family, endemic to Mexico which grows naturally as an epiphyte.",
    quantity: 1,
  },
  {
    id: 15,
    name: "Macodes Petola Gold",
    image: plant15,
    size: "small",
    price: 13,
    description: "Macodes Petola Gold is a jewel orchid with leaves that look as if they are covered in lightnings! Different to the normal Macodes Petola, Macodes Petola Gold has leaves with a brownish green hue and prominent golden veins instead of silver, netting the leaf surface.",
    quantity: 1,
  },
  {
    id: 16,
    name: "Philodendron hederaceum",
    image: plant16,
    size: "medium",
    price: 25,
    description: "Philodendron hederaceum var hederaceum is one of our favourite Aroids due to its gorgeous, velvety leaves! Also known as Philodendron Micans, new leaves on this plant will be light brown to bright green in colour, but mature into an iridescent deep green with a brown hue.",
    quantity: 1,
  },
  {
    id: 17,
    name: "Philodendron Pink Princess",
    image: plant17,
    size: "medium",
    price: 235,
    description: "Philodendron Pink Princess is a terrific climbing Aroid with dark leaves and light pink variegated blotches. It is one of the most popular houseplants these days and for good reason: This Aroid is as beautiful as it is easy to care for!",
    quantity: 1,
  },
  {
    id: 18,
    name: "String of Turtles",
    image: plant18,
    size: "medium",
    price: 15,
    description: "The String of Turtles, also known as Peperomia Prostrata, thanks its name to the small leaves resembling a turtle shell. It is one of the most interesting patterns in plants we have ever seen and it will grow into a rain of mesmerizing leaves.",
    quantity: 1,
  },
  {
    id: 19,
    name: "Philodendron White Knight",
    image: plant19,
    size: "medium",
    price: 180,
    description: "Philodendron White Knight is a highly sought-after Aroid with lush green, round leaves that feature beautiful sectoral and speckled, white variegation. This is a true must-have for lovers of rare plants and variegation!",
    quantity: 1,
  },
  {
    id: 20,
    name: "Plumosa Fern asparagus",
    image: plant20,
    size: "medium",
    price: 18,
    description: "Plumosa Asparagus Fern is a delicate plant with graceful feathery and fern-like foliage. The plant can be used in many elegant floral arrangements and home decoration. Plumosa fern is not a fern. It belongs to the asparagus family. It is very easy to care for.",
    quantity: 1,
  },
  {
    id: 21,
    name: "Hoya Linearis",
    image: plant21,
    size: "medium",
    price: 30,
    description: "Hoya linearis is a tender, pendent, epiphytic, succulent, evergreen perennial with slender, soft, green stems bearing linear, hairy, grooved leaves and lax clusters of fragrant, star-shaped, white flowers from late summer into autumn.",
    quantity: 1,
  },

  {
    id: 4,
    name: "Alocasia Zebrina",
    image: plant4,
    size: "medium",
    price: 15,
    description:
      "Alocasia Zebrina has unique striped stems and arrowhead leaves. An amazing plant for everyone who loves zebras and plants",
    quantity: 1,
  },

  {
    id: 5,
    name: "Calathea Lancifolia (Rattlesnake Plant)",
    image: plant5,
    size: "big",
    price: 12,
    description:
      "Calathea Lancifolia, commonly known a Rattlesnake Plant is a perfect plant for a pattern lover! It has bright green wavy leaves with purple underside that are adorned with alternating ovals of dark green.",
    quantity: 1,
  },

  {
    id: 6,
    name: "Ficus Elastica Tineke",
    image: plant6,
    size: "big",
    price: 18,
    description:
      "Ficus Elastica Tineke is a colorful variegated beauty. Native to the central Asian tropics this tree is fast growing throughout the summer months.",
    quantity: 1,
  },

  {
    id: 7,
    name: "Monstera Deliciosa",
    image: plant7,
    size: "big",
    price: 15,
    description:
      "All time classic - the iconic Monstera Deliciosa also commonly known as fruit salad or swiss cheese plant. The split leaves are so beautiful that they ve been extensively used in art and design.",
    quantity: 1,
  },

  {
    id: 8,
    name: "Philodendron Gloriosum",
    image: plant8,
    size: "medium",
    price: 135,
    description:
      "Philodendron Gloriosum is a very desirable and rare plant for all aroid lovers. The heart-shaped foliage is incredibly velvety which makes it the perfect plant for every indoor jungle!",
    quantity: 1,
  },

  {
    id: 9,
    name: "Philodendron Verrucosum",
    image: plant9,
    size: "medium",
    price: 89,
    description:
      "Philodendron Verrucosum is one of the most spectacular philodendrons out there! It has iridescent deep green velvety leaves with bright veins, red back and hairy stems. Simply beautiful!",
    quantity: 1,
  },

  {
    id: 10,
    name: "Pilea Peperomioides (Chinese Money Plant)",
    image: plant10,
    size: "small",
    price: 10,
    description:
      "Pilea peperomioides, also known as Chinese money plant, pancake plant, friendship plant, or ufo plant… we lost the count with the names! It is a species of flowering plants in the family Urticaceae, native to Yunnan Province in southern China.",
    quantity: 1,
  },

  {
    id: 11,
    name: "Epipremnum Aureum",
    image: plant11,
    size: "medium",
    price: 9,
    description:
      "Epipremnum Aureum is a beautiful vine with glowing, green foliage. Commonly known as Pothos, it can flourish in pretty dark places and despite some neglect, making it a perfect houseplant for starters!",
    quantity: 1,
  },

  {
    id: 12,
    name: "Scindapsus Pictus Exotica",
    image: plant12,
    size: "medium",
    price: 9,
    description:
      "Scindapsus Pictus Exotica, also known as Satin Pothos, is part of the Aracae family and known for its large matte green foliage with silver markings.",
    quantity: 1,
  },

  {
    id: 3,
    name: "Alocasia Portodora",
    image: plant3,
    size: "medium",
    price: 15,
    description:
      "Alocasia Portodora has playful lush green arrowhead-shaped leaves. It can grow quite big so make some space. It requires bright indirect light and high humidity.",
    quantity: 1,
  },
];

export default plants;
